export enum IntegrationPaths {
  INDEX = '/integration-config',
  TELEGRAM = '/integration-config/telegram/telegram-bot-config',
  WEB_SITE = '/integration-config/web-site/web-site-config',
  AMO_CRM = '/integration-config/amo-crm/amo-crm-config',
  MARKET_PLACE = '/integration-config/market-place/market-place-config',
  BOT_INTERFACE = '/interface/bot-interface'
}
